import React from "react";
import Checkbox from "@mui/material/Checkbox";

function AdmissionAssessorNotice({ clientUnderstand, handleClientUnderstand }) {
  return (
    <div className="container-main-plan">
      <div className="tab-container-title" style={{ paddingLeft: 20 }}>
        Assessor: Read to the potential client or their representative when
        pre-admission assessment questions are completed:
      </div>

      <div className="tab-container-subtitle">
        Please understand that any information that you provided which is false
        or misleading (for example, you omitted important information in your
        response to any of the questions asked of you during this clinical
        assessment) can result in non-admission into Miracles Asiaâ€™s Program or
        an Administrative Discharge if admitted into Miracles Asiaâ€™s program.
        This clinical assessment is for your benefit, that is, to make sure
        Miracles Asia is the appropriate and best provider to meet your needs.
      </div>

      <div className="tab-container-subtitle">
        [Ask the potential client]: Do you understand what I just read you?
      </div>

      <div className="tab-container-subtitle">
        [If the person says, â€œyes,â€ Check the box]:
        <Checkbox checked={clientUnderstand} onChange={handleClientUnderstand} />
      </div>

      <div className="tab-container-subtitle">
        [If the person says, â€œno,â€ assist him/her to understand and then check
        the box above.]
      </div>
    </div>
  );
}

export default AdmissionAssessorNotice;

